export enum FavouriteSectionType {
  Details = 'details',
  Schedule = 'schedule',
  Recipients = 'recipients',
  SharedWith = 'sharedWith',
  Dashboards = 'dashboards',
  CompanyReports = 'companyReports',
  Translations = 'translations'
}
